import { recognitionMetricKeys, type CaptureProfile, type NormalizedRect } from '@/domain/types'

const colorMetrics = ['hp', 'mp', 'exp'] as const

function cloneRect(rect: NormalizedRect): NormalizedRect {
  return { x: rect.x, y: rect.y, width: rect.width, height: rect.height }
}

export function cloneCaptureProfile(profile: CaptureProfile): CaptureProfile {
  const roiOverrides: CaptureProfile['roiOverrides'] = {}
  for (const metric of recognitionMetricKeys) {
    const rect = profile.roiOverrides[metric]
    if (rect) roiOverrides[metric] = cloneRect(rect)
  }

  const colorCalibration: CaptureProfile['colorCalibration'] = {}
  for (const metric of colorMetrics) {
    const color = profile.colorCalibration[metric]
    if (color) colorCalibration[metric] = [color[0], color[1], color[2]]
  }

  return {
    ...profile,
    ...(profile.attributeSources ? { attributeSources: Object.fromEntries(Object.entries(profile.attributeSources).map(([metric, source]) => [metric, {
      ...source, ...(source.region ? { region: { rect: cloneRect(source.region.rect), valueRect: cloneRect(source.region.valueRect),
        anchor: cloneRect(source.region.anchor), signature: [...source.region.signature] } } : {}),
    }])) } : {}),
    ...(profile.autoRois ? { autoRois: Object.fromEntries(Object.entries(profile.autoRois).map(([metric, region]) => [metric, {
      ...region, rect: cloneRect(region.rect),
      ...(region.textRect ? { textRect: cloneRect(region.textRect) } : {}),
      ...(region.barRect ? { barRect: cloneRect(region.barRect) } : {}),
    }])) } : {}),
    hudRect: cloneRect(profile.hudRect),
    roiOverrides,
    colorCalibration,
    recognition: {
      ...profile.recognition,
      ...(profile.recognition.metricCaptureFps
        ? { metricCaptureFps: { ...profile.recognition.metricCaptureFps } }
        : {}),
      ...(profile.recognition.metricRecognitionIntervalsMs
        ? { metricRecognitionIntervalsMs: { ...profile.recognition.metricRecognitionIntervalsMs } }
        : {}),
    },
  }
}
